import React from 'react';
import CloroxLinealities from 'components/Tvendo/Sale/QuotaBPartner/Clorox/LinealitiesClorox/List.js';

export default function () {
  return <CloroxLinealities />;
}
